const hairstyles = [
  {
    name: "Tuns Simplu",
    description:
      "O tăietură clasică și rafinată, potrivită pentru bărbații care apreciază eleganța și simplitatea.",
    price: 40,
  },
  {
    name: "Tuns Modern",
    description:
      "O tăietură modernă și îndrăzneață, cu contururi precise și stil urban, perfecta pentru un aspect contemporan",
    price: 55,
  },
  {
    name: "Tuns Barba",
    description:
      "O tunsoare precisă și bine definită pentru barba ta, oferind un aspect îngrijit și masculin, adaptată perfect formei feței tale.",
    price: 25,
  },
];

// potrivită pentru cei care doresc o tăietură unică și memorabilă.
// "O tăietură modernă și îndrăzneață, cu contururi precise și stil urban, perfectă pentru cei care caută un aspect contemporan.",

const heroSection = {
  title1: `Din cartieru' tau`,
  title2: `FRIZERIA`,
  title3: `HISTORY`,
  paragraph1: `Deși suntem la începutul călătoriei noastre, avem o viziune clară
    pentru ceea ce dorim să realizăm: să devenim un punct de referință
    în comunitatea noastră pentru servicii de frizerie de înaltă
    calitate și pentru o experiență primitoare și relaxantă. Cu
    fiecare zi care trece, ne angajăm să creăm un spațiu în care
    clienții noștri se simt speciali și îngrijiți.`,
  paragraph2: `Pentru noi, fiecare client care trece pragul frizeriei noastre
  este un partener în această aventură plină de culoare și stil.`,
  buttonText: "FA-MI O PROGRAMARE",
};

const storySection = {
  title1: `POVESTE`,
  title2: `PE SCURT...`,
  paragraph1: `Într-un cartier vibrant, cu străzi pline de viață și energie, se
    deschide o nouă frizerie, gata să redefinească standardele de
    frumusețe și stil. Proprietarul, Horatiu, a visat mereu să creeze
    un spațiu care să îmbine tradiția frizeriei clasice cu notele
    moderne ale stilului și confortului.`,
  paragraph2: `Cu un pumn de curaj și o doză sănătoasă de pasiune, Horatiu a
    transformat un spațiu modest într-o oază de frumusețe și relaxare.
    Atmosfera din interior este plină de căldură și prietenie, iar
    fiecare client este întâmpinat cu un zâmbet călduros și o
    atitudine primitoare.`,
  paragraph3: `De la scaunul de frizerie, se aud râsete și discuții pline de
    viață, iar mâinile dibace ale lui Horatiu transformă fiecare
    tăietură într-o expresie a stilului și personalității fiecărui
    client.`,
  paragraph4: `În spatele oglinzilor, se desfășoară nu doar tunsori, ci și
    povești de transformare și încredere. Fiecare vizită la frizerie
    devine o experiență de neuitat, iar clienții pleacă nu doar cu o
    nouă coafură, ci și cu o stare de bine și încredere în propria
    frumusețe.`,
  paragraph5: `Astfel, această frizerie devine un sanctuar al stilului și al
    încrederii, un loc unde fiecare client este tratat cu respect și
    atenție, iar fiecare vizită este o călătorie către propria
    frumusețe și încredere în sine.`,
};

const servicesSection = {
  title1: `SERVICII`,
  title2: `ASPECT IMPECABIL, FARA COMPROMISURI`,
  paragraph1: `La frizeria noastră, fiecare serviciu este adaptat nevoilor și
  preferințelor dumneavoastră unice. Vă ascultăm cu atenție și colaborăm
  cu dumneavoastră pentru a crea un aspect care să vă reprezinte și să
  vă facă să vă simțiți încrezători în fiecare zi.`,
  hairstyles: hairstyles,
};

const teamSection = {
  title1: `ECHIPA`,
  title2: `O MÂNĂ PRICEPUTĂ`,
  paragraph1: `În spatele fiecărei tunsori remarcabile se află mâna pricepută a frizerului nostru. Cu ani de experiență și o pasiune autentică pentru frizerie, suntem dedicați să vă oferim cele mai bune servicii într-o atmosferă plăcută și relaxantă.`,
};

const contact = {
  info: {
    1: "Bulevardul 1848",
    2: "Strada Caraiman",
    3: "Telefon: 0727 082 781",
    4: "Email: hory_alex@yahoo.com",
  },
  hours: {
    1: "Luni: 08:00 - 18:00",
    2: "Marti: 08:00 - 18:00",
    3: "Miercuri: 08:00 - 18:00",
    4: "Joi: 08:00 - 18:00",
    5: "Vineri: 08:00 - 18:00",
    6: "Sambata: Închis",
    7: "Duminica: Închis",
  },
  hoursMobile: {
    1: "Luni-Vineri: 09:00 - 17:00",
    6: "Sambata: Închis",
    7: "Duminica: Închis",
  },
};

export { heroSection, storySection, servicesSection, teamSection, contact };
